import { useEffect, useState } from 'react';
import NavBar from "../components/NavBar";
import { useSelector } from "react-redux";
import { RootState } from '../store/store';
import PlaceCard from '../components/PlaceCard';
import Grid from '@mui/material/Grid';
import EmptySavedPlaces from './EmptySavedPlaces';
import { Box } from "@mui/material";
import { getMultiplePlaceImages } from '../utils/placesImageUtils';

interface SavedPlaceWithImage {
    id: string;
    name: string | null | undefined;
    imageUrl: string | null;
    city: string | null;
    country: string | null;
}

export default function Save(){
    const savedPlaces = useSelector((state: RootState) => state.savedPlaces);
    const [placesWithImages, setPlacesWithImages] = useState<SavedPlaceWithImage[]>([]);
    const [imagesLoading, setImagesLoading] = useState(true);

    useEffect(() => {
        const fetchImages = async () => {
            if (Object.keys(savedPlaces.items).length > 0) {
                setImagesLoading(true);
                const placesArray = Object.values(savedPlaces.items);
                const imageData = await getMultiplePlaceImages(placesArray);
                
                const placesWithImageUrls = placesArray.map(place => {
                    const imageInfo = imageData.find(img => img.id === place.id);
                    return {
                        ...place,
                        imageUrl: imageInfo?.imageUrl || null
                    };
                });
                
                setPlacesWithImages(placesWithImageUrls);
                setImagesLoading(false);
            } else {
                setPlacesWithImages([]);
                setImagesLoading(false);
            }
        };

        if (!savedPlaces.loading) {
            fetchImages();
        }
    }, [savedPlaces.items, savedPlaces.loading]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: `calc(100 * var(--vh))` }}>
            <NavBar/>
            {Object.keys(savedPlaces.items).length? (
                <Box
                sx={{
                    flex: 1, // Takes remaining space after NavBar
                    overflowY: 'auto',
                    padding: '16px',
                    paddingBottom: `calc(16px + var(--safe-area-inset-bottom))`, // Accounts for mobile browser bar
                    scrollbarWidth: "none",
                }}
                >
                    <Grid container rowSpacing={2} spacing={1} className='PlaceCard'>
                        {imagesLoading ? (
                            // Show loading state while fetching images
                            Object.values(savedPlaces.items).map((p, index) => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={p.id}>
                                    <Box sx={{ paddingRight: index % 1 === 0 ? '25px' : 0 }}>
                                        <PlaceCard
                                            id={p.id}
                                            name={p.name || ''}
                                            imageUrl="" // Show loading state
                                            city={p.city || ''}
                                            country={p.country || ''}
                                            saved={true}
                                        />
                                    </Box>
                                </Grid>
                            ))
                        ) : (
                            placesWithImages.map((p, index) => {
                                const itemsPerRow = { xs: 1 };
                                const isXs = index % itemsPerRow.xs === 0;
                                if (p.name && p.imageUrl && p.city && p.country) {
                                    return (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={p.id}>
                                            <Box sx={{ paddingRight: isXs ? '25px' : 0 }}>
                                                <PlaceCard
                                                    id={p.id}
                                                    name={p.name}
                                                    imageUrl={p.imageUrl}
                                                    city={p.city}
                                                    country={p.country}
                                                    saved={true}
                                                />
                                            </Box>
                                        </Grid>
                                    );
                                }
                                return null;
                            })
                        )}

                    </Grid>
                </Box>
            ) :
                <div style={{ flex: 1 }}>
                    <EmptySavedPlaces />
                </div>
            }
        </div>
    );
}
